<template>
  <div class>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>手机号</label>
          <input
            v-model.trim="search.mobile"
            class="form-control"
            type="text"
            placeholder
            size="12"
          />
        </div>
        <div class="form-group">
          <label for>车牌</label>
          <input
            v-model.trim="search.plate"
            class="form-control"
            type="text"
            placeholder
            size="12"
          />
        </div>
        <div class="form-group">
          <label for="bdate">注册时间</label>
          <bosk-shortcut-datetime v-on:current-datetime-change="onCurrentDatetimeChange"></bosk-shortcut-datetime>
        </div>
    
        <div class="form-group others">
          <span class="search_btn">
            <button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              查询
            </button>
          </span>
          <!-- <button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
          <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
        <div class="form-group others">
          <button
            @click="downloadData"
            type="button"
            class="btn btn-primary"
            id="search_btn"
          >
            导出
          </button>
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column
          show-overflow-tooltip
          label="手机号"
          prop="mobile"
        ></el-table-column>
        <!-- <el-table-column show-overflow-tooltip label="时间" prop="crtTime"> -->
        <!-- <template slot-scope='scope'>
					{{scope.row.parkingType|handelParkingType}}
          </template>-->
        <!-- </el-table-column> -->

        <el-table-column
          show-overflow-tooltip
          label="充值金额"
          prop="money"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="赠送金额"
          prop="giftAmount"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="车牌"
          prop="attr1"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="推荐人"
          prop="referrer"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="注册时间"
          prop="crtTime"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="自动扣款"
          prop="autoPay"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <!-- <a title="查看" href="javascript:;" @click="photo(scope.row.id)"><span>查看</span></a>&nbsp;&nbsp; -->
            <button
              class="operate-button"
              title="充值"
              href="javascript:;"
              @click="onRechargeBtn(scope.row.id)"
            >
              充值
            </button>
            <button
              :class="{ isNotActived: !scope.row.attr1 }"
              class="operate-button"
              title="解绑车牌"
              href="javascript:;"
              @click="onUnbindPlateBtn(scope.row.id, scope.row.attr1)"
            >
              解绑车牌
            </button>
            <button
              class="delete"
              title="删除"
              href="javascript:;"
              @click="
                onbReduceMoneyBtn(
                  scope.row.id,
                  scope.row.money,
                  scope.row.giftAmount
                )
              "
            >
              消除金额
            </button>
          </template>
        </el-table-column>
      </el-table>
      <div class="total-amount"><span>金额统计:</span><span>充值金额:</span><span>{{userTotalAmount.rechargeAmount}}</span><span>赠送金额:</span><span>{{userTotalAmount.giftAmount}}</span></div>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 照片 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      :title="'行驶证（车牌：' + plateNum + '）'"
      :visible.sync="dialogFormVisiblePhoto"
      width="500px"
      @close="closeDialogPhoto"
    >
      <el-form ref label-position="right" :label-width="formLabelWidth" id>
        <div class="modal-body">
          <!-- <div class="chkimg" style="text-align:center;overflow:hidden;">
                        <img :src="imgUrl" alt="" style="max-height:500px;max-width:540px;">
          </div>-->

          <div class="chkimg" style="text-align: center; overflow: hidden">
            <img
              :src="imgUrl"
              alt
              style="max-height: 300px; max-width: 540px"
            />
          </div>
          <ul class="tab-img clearfix">
            <li
              class="fl"
              @click="handleClickTag(item)"
              v-for="(item, index) in allImgUrl"
              :key="index"
            >
              <a href="javascript:;">
                <img
                  :src="item.carNumberPhoto"
                  alt
                  width="100%"
                  height="100%"
                />
              </a>
            </li>
          </ul>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisiblePhoto = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <recharge-popup
      :dialogFormVisible="recharge.dialogFormVisible"
      :id="recharge.userId"
      @func="closeDialogRecharge"
    ></recharge-popup>
    <plate-popup :plate="plate" @func="closeDialogPlate"></plate-popup>
    <reduce-money-popup
      :reduceMoney="reduceMoney"
      @func="closeDialogReduceMoney"
    ></reduce-money-popup>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  getCarUserList,
  getLicense,
  delUser,
  reqReduceMoney,
  reqUserTotalAmount,
} from "@/api/url";

// import Refresh from "../commons/refresh.vue";

import Page from "../../commons/page";

import RechargePopup from "../components/rechargePopup";
import PlatePopup from "../components/platePopup";
import ReduceMoneyPopup from "../components/reduceMoneyPopup";

export default {
  data() {
    return {
      recharge: {
        dialogFormVisible: false,
        userId: "",
      },
      plate: {
        dialogFormVisible: false,
        userId: "",
      },
      reduceMoney: {
        dialogFormVisible: false,
        userId: "",
      },
      userlist_btn_delete: false,
      userTotalAmount:{},
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        userName: "",
        mobile: "",
        plate: "",
        startTime: "",
        endTime: "",
      },
      tableListData: [],

      formLabelWidth: "100px",
      dialogFormVisible: false,
      allType: [
        {
          label: "普通用户",
          value: "0",
        },
        {
          label: "管理员用户",
          value: "1",
        },
      ],
      form: {
        id: "",
        userName: "",
        type: "0",
      },
      rules: {
        userName: [
          { required: true, message: "请填写场景名称", trigger: "blur" },
          {
            min: 3,
            max: 12,
            message: "长度在 3 到 12 个字符",
            trigger: "blur",
          },
        ],
        type: [{ required: false, message: "请填写场景名称", trigger: "blur" }],
      },

      dialogFormVisiblePhoto: false,

      allImgUrl: [],
      plateNum: "",
      imgUrl: "",
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage, open) {
      this.$get(getCarUserList(), {
        name: this.search.userName,
        mobile: this.search.mobile,
        limit: this.search.pageSize,
        page: curPage,
        beginTime: this.search.startTime,
        endTime: this.search.endTime,
        plate: this.search.plate,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // this.getPage(pageObj);
        this.pageObj={...pageObj}
        const {
          data: { rows },
        } = data;
        this.tableListData = rows.map((item) => {
          item.giftAmount = Number(item.giftAmount).toFixed(2);
          item.money = Number(item.money).toFixed(2);
          return item;
        });
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      });
    },
    searchList: function () {
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
      this. getUserTotalAmount()
    },
    timeCompare: function (bDateVal, eDateVal) {
      // console.log(bDateVal,eDateVal);

      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }

      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      return bdate - edate > 0
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.userName = "";
      this.search.mobile = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    closeDialogPhoto: function () {
      this.allImgUrl = [];
      this.imgUrl = "";
      this.plateNum = "";
    },
    photo: function (id) {
      this.dialogFormVisiblePhoto = true;
      this.$postRequest(getLicense(), {
        userId: id,
      }).then((data) => {
        if (data.status != 200) return;
        var result = data.data.rows;
        for (var i = 0; i < result.length; i++) {
          this.allImgUrl.push(result[i]);
        }
        if (Boolean(result.length)) {
          this.imgUrl = this.allImgUrl[0].carNumberPhoto;
          this.plateNum = this.allImgUrl[0].carNumber;
        }
      });
    },
    handleClickTag: function (obj) {
      this.imgUrl = obj.carNumberPhoto;
      this.plateNum = obj.carNumber;
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该车主？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(delUser() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.tableList(_this.search.pageNumber);
          });
        }
      );
    },

    onRechargeBtn(id) {
      this.recharge = {
        userId: id,
        dialogFormVisible: true,
      };
    },
    closeDialogRecharge(m) {
      if (m === "success") {
        this.tableList(this.search.pageNumber);
      }
      this.recharge = {
        userId: "",
        dialogFormVisible: false,
      };
    },
    onUnbindPlateBtn(id, plateNum) {
      if (!plateNum) return;
      this.plate = {
        userId: id,
        dialogFormVisible: true,
      };
    },
    closeDialogPlate(m) {
      if (m === "success") {
        this.tableList(this.search.pageNumber);
      }
      this.plate = {
        userId: "",
        dialogFormVisible: false,
      };
    },
    onbReduceMoneyBtn(id, rechargeMoney, giftMoney) {
      this.reduceMoney = {
        userId: id,
        money: rechargeMoney,
        giftAmount: giftMoney,
        dialogFormVisible: true,
      };
    },
    closeDialogReduceMoney(m) {
      if (m === "success") {
        this.tableList(this.search.pageNumber);
      }
      this.reduceMoney = {
        userId: "",
        dialogFormVisible: false,
      };
    },
    getUserTotalAmount() {
      this.$get(reqUserTotalAmount(), {
        name: this.search.userName,
        mobile: this.search.mobile,
        beginTime: this.search.startTime,
        endTime: this.search.endTime,
        plate: this.search.plate,
      }).then((res) => {
        const { status, data:{giftAmount,rechargeAmount} } = res;
        this.userTotalAmount ={
          giftAmount:Number(giftAmount).toFixed(2)??"0.00",
          rechargeAmount:Number(rechargeAmount).toFixed(2)??"0.00"
        } ;
      });
    },
    downloadData() {
      this.$downloadFileRequest(
        "/api/parking/appUser/export",
        {
          name: this.search.userName,
          mobile: this.search.mobile,
          beginTime: this.search.startTime,
          endTime: this.search.endTime,
          plate: this.search.plate,
        },
        "车主管理"
      );
    },
    onCurrentDatetimeChange(v){
      this.search.startTime=v?.[0]??''
      this.search.endTime=v?.[1]??''
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.userlist_btn_delete = this.elements["userlist:btn_delete"];
    },
  },
  components: {
    Page,
    RechargePopup,
    PlatePopup,
    ReduceMoneyPopup,
    // Refresh
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.tableList(this.search.pageNumber);
    this. getUserTotalAmount();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.isNotActived {
  color: gray;
}
.total-amount{
  text-align: center;
  span{
    display:inline-block;
    box-sizing: border-box;
    padding-right: 10px;
    &:nth-child(2n+1){
      color:red;
      font-size:16px;
      font-weight: bold;
    }
  }
}
</style>